






























import { Component, Vue } from 'vue-property-decorator';
import { CustomerFilter, DeleteResultModel, StSelectListItem, TagFilter, TagViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stCustomerApi, stTagApi } from '@/services/st-api';
import StInput2 from '@/components/basic/StInput2.vue';
import StSearch from '@/components/basic/StSearch.vue';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    StSearch,
    StInput2,
  },
})
export default class Test extends Vue {
  customers: StSelectListItem[] = [];
  customerIds: any[] = [];
  customerId: any = null;
  show: boolean = false;
  async loadLookups() {
    this.customers = await stCustomerApi.getSelectList(CustomerFilter.fromJS({ isArchived: false }));
  }

  setValues() {
    this.customerIds = this.customers.map(_=>_.id).slice(0,2);
    this.customerId = this.customers.map(_=>_.id)[1];
  }

  setVisibility() {
    this.show = !this.show;
  }

}
